export default __webpack_public_path__ + "static/media/invite-icon.61f85389.svg";